import { Card } from './styles';

import NoData from '../../../../../components/NoData';
import { LinesType } from '../../types';

interface LinesCardInterface {
  dashboardLinesData: LinesType;
  selectedWorkplace: { value: number, label: string };
}

export default function LinesCard({ dashboardLinesData, selectedWorkplace }: LinesCardInterface) {
  return (
    <Card>
      <div className="card-title">
        <div>Linhas</div>
      </div>

      {dashboardLinesData && (
        <>
          <div className="card-main">
            <div>
              {dashboardLinesData.qtdLinhas}
            </div>
            <small>
              {(dashboardLinesData.qtdLinhas > 1 ? 'Linhas' : 'Linha')}
            </small>
          </div>

          <footer>
            {(!dashboardLinesData.linBaixou) && (
              <>
                <div className="porcentagem-negativa">
              +
                  {' '}
                  {dashboardLinesData.percLinha}
              %
                </div>
                <div>
              Em relação ao início da operação
                </div>
              </>
            )}
            {(dashboardLinesData.linBaixou) && (
              <>
                <div className="porcentagem-positiva">
              -
                  {' '}
                  {dashboardLinesData.percLinha}
              %
                </div>
                <div>
              Em relação ao início da operação
                </div>
              </>
            )}
          </footer>
        </>
      )}

      {(!dashboardLinesData) && (
        <NoData
          icon="emptyBox"
          label={(
            <>
            O local de trabalho
              {' '}
              <strong>{selectedWorkplace.label}</strong>
              {' '}
            não possui dados de linhas.
            </>
          )}
        />
      )}

    </Card>
  );
}
